import isPlainObject from 'lodash-es/isPlainObject';

export const deepMapKeys = (
  input: object,
  convertKey: (key: string) => string
): object => {
  if (Array.isArray(input)) {
    return input.map((val) => deepMapKeys(val, convertKey));
  }

  if (isPlainObject(input)) {
    const inputObject = input as Record<string, object>;
    const result: Record<string, object> = {};

    for (const key in inputObject) {
      if (Object.prototype.hasOwnProperty.call(inputObject, key)) {
        result[convertKey(key)] = deepMapKeys(inputObject[key], convertKey);
      }
    }
    return result;
  }

  return input;
};
